"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg24HomeLine = function Svg24HomeLine(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79 3.185L3.495 8.081c-.213.166-.454.353-.641.523l-.012.01c-.142.129-.63.568-.808 1.27a2.5 2.5 0 0 0 .889 2.59c.375.291.785.412 1.077.465v4.507c0 .238 0 .523.02.774.024.29.085.706.307 1.142a3 3 0 0 0 1.311 1.311c.436.222.852.283 1.142.307.251.02.535.02.774.02h8.892c.238 0 .523 0 .774-.02.29-.024.706-.085 1.142-.307a3 3 0 0 0 1.311-1.311c.222-.436.283-.852.307-1.142.02-.251.02-.535.02-.774V12.94a2.468 2.468 0 0 0 1.077-.465 2.5 2.5 0 0 0 .889-2.59c-.179-.702-.666-1.141-.808-1.27l-.012-.01c-.187-.17-.428-.357-.64-.523L14.21 3.185l-.068-.053c-.242-.194-.746-.595-1.358-.76a3 3 0 0 0-1.568 0c-.612.165-1.116.566-1.358.76l-.068.053zm1.949 1.117c-.194.052-.37.189-.721.462L4.763 9.629c-.499.388-.748.582-.79.748a.5.5 0 0 0 .177.518c.136.105.452.105 1.084.105.248 0 .372 0 .47.043a.504.504 0 0 1 .253.254c.043.097.043.221.043.47V17.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C6.76 19 7.04 19 7.6 19h1.9v-4.5a2.5 2.5 0 0 1 5 0V19h1.9c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C18 18.24 18 17.96 18 17.4v-5.634c0-.248 0-.372.043-.47a.49.49 0 0 1 .254-.253c.097-.043.221-.043.47-.043.631 0 .947 0 1.083-.105a.5.5 0 0 0 .177-.518c-.042-.166-.291-.36-.79-.748l-6.255-4.865c-.351-.273-.527-.41-.72-.462a1 1 0 0 0-.523 0z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg24HomeLine.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg24HomeLine;
exports.default = _default;